export const GLOBAL_STATE_FETCHING_START = "GLOBAL_STATE_FETCHING_START";
export const GLOBAL_STATE_FETCHING_END = "GLOBAL_STATE_FETCHING_END";
export const REQUEST_ERROR = "REQUEST_ERROR";
